import React, { useState } from "react";
import { muestraSeccionExtras } from "../mappers/productoMapper";
import { resolverImagenProducto } from "../utils/imagenProducto";

function formatearMonto(valor) {
  return Number(valor).toLocaleString("es-CL");
}

function ProductoCard({ producto, onClick, prioridad = false }) {
  const [usarOriginal, setUsarOriginal] = useState(false);
  const conTamanos = Boolean(producto.con_tamanos && producto.tamanos?.length);
  const muestraExtras = muestraSeccionExtras(producto);
  const nombresTamanos = conTamanos
    ? producto.tamanos.map((tamano) => tamano.nombre).filter(Boolean)
    : [];
  const imagen = resolverImagenProducto(producto.imagen_url, "tarjeta");
  const src = imagen ? (usarOriginal ? imagen.original : imagen.src) : "";

  return (
    <div className="card h-100 border-0 shadow-sm producto-card" onClick={() => onClick(producto)} style={{ cursor: "pointer" }}>
      {imagen ? (
        <img
          src={src}
          srcSet={usarOriginal ? undefined : imagen.srcSet}
          sizes={usarOriginal ? undefined : imagen.sizes}
          className="card-img-top"
          alt={producto.nombre}
          loading={prioridad ? "eager" : "lazy"}
          fetchPriority={prioridad ? "high" : "auto"}
          decoding="async"
          onError={() => {
            if (!usarOriginal && imagen.src !== imagen.original) {
              setUsarOriginal(true);
            }
          }}
          style={{
            height: 140,
            objectFit: "contain",
            objectPosition: "center",
            backgroundColor: "#f3f3f3",
            borderRadius: "16px 16px 0 0",
          }}
        />
      ) : (
        <div
          aria-hidden
          style={{
            height: 140,
            backgroundColor: "#f3f3f3",
            borderRadius: "16px 16px 0 0",
          }}
        />
      )}
      <div className="card-body d-flex flex-column text-center">
        <h6 className="card-title fw-bold producto-card__nombre">{producto.nombre}</h6>
        <div className="text-muted small producto-card__categoria">{producto.categoria}</div>
        {conTamanos || muestraExtras ? (
          <div className="producto-card__opciones">
            <div className="producto-card__badges">
              {conTamanos ? (
                <span className="badge rounded-pill text-bg-dark">Tamaños</span>
              ) : null}
              {muestraExtras ? (
                <span className="badge rounded-pill text-bg-dark">Armable</span>
              ) : null}
            </div>
            {conTamanos && nombresTamanos.length > 0 && nombresTamanos.length <= 4 ? (
              <div className="text-muted small">{nombresTamanos.join(" · ")}</div>
            ) : null}
            {muestraExtras ? (
              <div className="text-muted small">
                Hasta {producto.armable_cantidad}{" "}
                {producto.armable_cantidad === 1 ? "ingrediente" : "ingredientes"}
              </div>
            ) : null}
          </div>
        ) : null}
        <div className="mb-3 fw-semibold" style={{ fontSize: 19 }}>
          {conTamanos
            ? `desde $${formatearMonto(producto.precio)}`
            : `$${formatearMonto(producto.precio)}`}
        </div>
      </div>
    </div>
  );
}

export default React.memo(ProductoCard);
